import React, { useEffect, useState } from 'react';
import { UserCircle } from 'lucide-react';

const SIZE_CLASSES = {
  sm: 'w-7 h-7 sm:w-8 sm:h-8',
  md: 'w-10 h-10',
  lg: 'w-14 h-14 sm:w-16 sm:h-16',
  xl: 'w-20 h-20 sm:w-28 sm:h-28',
};

const ICON_CLASSES = {
  sm: 'w-5 h-5 sm:w-6 sm:h-6',
  md: 'w-6 h-6',
  lg: 'w-8 h-8 sm:w-9 sm:h-9',
  xl: 'w-12 h-12 sm:w-16 sm:h-16',
};

const UserAvatar = ({
  src,
  alt = '',
  size = 'md',
  className = '',
  iconClassName = 'text-gray-400',
}) => {
  const photoUrl = typeof src === 'string' ? src.trim() : '';
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    setFailed(false);
  }, [photoUrl]);

  const sizeClass = SIZE_CLASSES[size] || SIZE_CLASSES.md;
  const iconClass = ICON_CLASSES[size] || ICON_CLASSES.md;
  const showPhoto = Boolean(photoUrl) && !failed;

  return (
    <div
      className={`${sizeClass} rounded-full overflow-hidden bg-gray-100 border border-gray-200 flex items-center justify-center flex-shrink-0 ${className}`}
    >
      {showPhoto ? (
        <img
          src={photoUrl}
          alt={alt}
          className="w-full h-full object-cover"
          onError={() => setFailed(true)}
        />
      ) : (
        <UserCircle className={`${iconClass} ${iconClassName}`} aria-hidden="true" />
      )}
    </div>
  );
};

export default UserAvatar;
